const getters = {
  optionItem: state => state.settings.optionItem,
  companyId: state => state.settings.companyId,
  userInfo: state => state.settings.userInfo
}
export default getters
